<h2 class="text-center"> Creating Answer Template</h2>
<div calass="alert alert-info" *ngIf="!isCreated">
    Failed to save
    <ul>
        <i> Ensure there is a template list</i>
        <i> Ensure it has a name</i>
        <i> Check it again</i>
    </ul>
</div>
<form [formGroup]="myForm" (ngSubmit)="submit()">
    <div class="form-group">
        <label for="file">File</label>
        <input
            formControlName="file"
            id="file"
            type="file"
            class="form-control"
            (change)="onFileChange($event)">
            <div *ngIf="f.file.touched && f.file.invalid" class="alert alert-danger">
                <div *ngIf="f.file.errors.required">File is required.</div>
            </div>
        </div>
        <button class="btn btn-primary m-2" type="submit">Submit</button>

</form>
